import { Form, Formik, FormikHelpers } from "formik";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { WebCourseFormValues } from "src/models/WebCourse.model";
import { useEditWebcourseMutation } from "src/services/WebcourseServices";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import CourseContentForm from "./CourseContentForm";


const CourseContentFormWrapper = () => {

    const [updateWebCourse] = useEditWebcourseMutation();

    const { id = '' } = useParams();
    const navigate = useNavigate();
    const { webCourseDataLayout }: any = useOutletContext();

    // Form Initial Values
    const initialValues: WebCourseFormValues = {

        courseName: webCourseDataLayout?.courseName || '',
        courseModule: webCourseDataLayout.courseModule?.length ? webCourseDataLayout.courseModule?.map((module: any) => ({
            moduleName: module.moduleName || '',
            lession: module.lesson.map((lesson: any) => ({
                lessionName: lesson?.lessonName || '',
                lessionDescription: lesson.lessonDescription || '',
                documentType: lesson.documentType || '',
                documentLink: lesson.documentLink || '',
                videoType: lesson.videoType || '',
                lessonDuration: lesson?.lessonDuration || ''
            }))
        })) :
            [
                {
                    moduleName: '',
                    lession: [
                        {
                            lessionName: "",
                            lessionDescription: "",
                            documentType: "",
                            videoType: '',
                            documentLink: "",
                        }
                    ]

                },
            ],


    };

    // Validation Schema
    const validationSchema = object().shape({
        courseModule: array().of(
            object().shape({
                moduleName: string().required("Please enter module name"),
                lession: array().of(
                    object().shape({
                        lessionName: string().required("Please enter lesson name"),
                        lessionDescription: string().required("Please enter lesson description"),
                        documentType: string().required("Please select document type"),
                        // videoType: string().required("Please select video type"),
                        videoType: string().test(
                            'is-required-when-mcq',
                            'Please select video type',
                            function (value) {
                                const { documentType } = this.parent;
                                if (documentType === 'VIDEO') {
                                    return value !== undefined && value !== null;
                                }
                                return true;
                            }
                        ),
                        lessonDuration: string().test(
                            'is-required-when-mcq',
                            'Please enter lesson duration',
                            function (value) {
                                const { documentType } = this.parent;
                                if (documentType === 'VIDEO') {
                                    return value !== undefined && value !== null;
                                }
                                return true;
                            }
                        ),
                        documentLink: string().url("Please enter a valid URL for the document").required("Please enter document link"),
                    })
                ).min(1, "Please add at least one lesson")
            })
        ).min(1, "Please add at least one module")
    });

    // Handle Submit
    const handleSubmit = (
        values: WebCourseFormValues,
        { setSubmitting, resetForm }: FormikHelpers<WebCourseFormValues>
    ) => {
        const formatedValue = {
            courseName: values.courseName || '',
            courseModule: values.courseModule?.length ? values.courseModule?.map((module: any) => ({
                moduleName: module.moduleName || '',
                lesson: module.lession?.map((lesson: any) => ({
                    lessonName: lesson.lessionName || '',
                    lessonDescription: lesson.lessionDescription || '',
                    documentType: lesson.documentType || '',
                    videoType: lesson.videoType || '',
                    documentLink: lesson.documentLink || '',
                    lessonDuration: lesson.lessonDuration || '',
                }))
            })) : [],
        };

        updateWebCourse({ body: formatedValue, id: id }).then((res: any) => {
            if (res?.error) {
                showToast("error", res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    navigate(`/website-content/web-course/${id}/additional-details`)
                } else {
                    showToast("error", res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        // <Dialog open maxWidth="xs" fullWidth>
        <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {(formikProps) => (
                <Form className="h-full overflow-hidden contents">
                    <CourseContentForm
                        formikProps={formikProps}
                    />
                </Form>
            )}
        </Formik>
        // </Dialog>
    );
};

export default CourseContentFormWrapper;
